import React, { useState } from 'react';
import { Menu, X, Phone, Mail } from 'lucide-react';
import Logo from './Logo';

const Header: React.FC = () => {
  const [isMenuOpen, setIsMenuOpen] = useState(false);

  const navigation = [
    { name: 'Accueil', href: '#accueil' },
    { name: 'À propos', href: '#apropos' },
    { name: 'Prestations', href: '#prestations' },
    { name: 'Réalisations', href: '#realisations' },
    { name: 'Contact', href: '#contact' },
  ];

  return (
    <header className="bg-white shadow-sm border-b border-stone-200 sticky top-0 z-50">
      {/* Top bar avec contact */}
      <div className="bg-stone-50 border-b border-stone-200">
        <div className="container-max section-padding">
          <div className="flex justify-between items-center py-2 text-sm text-stone-600">
            <div className="hidden md:flex items-center space-x-6">
              <div className="flex items-center space-x-2">
                <Phone className="w-4 h-4" />
                <span>2 Rue Joseph le Brix, 56400 Plougoumelen</span>
              </div>
            </div>
            <div className="flex items-center space-x-4">
              <div className="flex items-center space-x-2">
                <Phone className="w-4 h-4" />
                <a href="tel:+33676825228" className="hover:text-wood-600">
                  +33 6 76 82 52 28
                </a>
              </div>
              <div className="flex items-center space-x-2">
                <Mail className="w-4 h-4" />
                <a href="mailto:contact@ars-agencement.bzh" className="hover:text-wood-600">
                  contact@ars-agencement.bzh
                </a>
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* Navigation principale */}
      <nav className="container-max section-padding">
        <div className="flex justify-between items-center py-4">
          {/* Logo */}
          <Logo size="medium" showText={true} />

          {/* Navigation desktop */}
          <div className="hidden lg:flex items-center space-x-8">
            {navigation.map((item) => (
              <a
                key={item.name}
                href={item.href}
                className="text-stone-700 hover:text-wood-600 font-medium transition-colors duration-200"
              >
                {item.name}
              </a>
            ))}
            <button 
              className="btn-primary"
              onClick={() => {
                const section = document.getElementById('contact');
                section?.scrollIntoView({ behavior: 'smooth' });
              }}
            >
              Demander un devis
            </button>
          </div>

          {/* Menu mobile button */}
          <div className="lg:hidden">
            <button
              onClick={() => setIsMenuOpen(!isMenuOpen)}
              className="p-2 rounded-md text-stone-700 hover:text-wood-600"
            >
              {isMenuOpen ? <X className="w-6 h-6" /> : <Menu className="w-6 h-6" />}
            </button>
          </div>
        </div>

        {/* Menu mobile */}
        {isMenuOpen && (
          <div className="lg:hidden border-t border-stone-200 py-4">
            <div className="flex flex-col space-y-4">
              {navigation.map((item) => (
                <a
                  key={item.name}
                  href={item.href}
                  className="text-stone-700 hover:text-wood-600 font-medium py-2"
                  onClick={() => setIsMenuOpen(false)}
                >
                  {item.name}
                </a>
              ))}
              <button 
                className="btn-primary w-full mt-4"
                onClick={() => {
                  const section = document.getElementById('contact');
                  section?.scrollIntoView({ behavior: 'smooth' });
                  setIsMenuOpen(false);
                }}
              >
                Demander un devis
              </button>
            </div>
          </div>
        )}
      </nav>
    </header>
  );
};

export default Header;
